import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenue.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Connexion échouée.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-ink grain flex items-center justify-center px-5">
      <div className="relative z-10 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="font-serif text-3xl text-white">GOLDEN <span className="gold-text">CAB</span></div>
          <p className="text-xs tracking-[0.35em] text-white/40 mt-1">ESPACE ADMINISTRATEUR</p>
        </div>
        <form onSubmit={submit} className="rounded-2xl border border-white/10 bg-panel p-8 space-y-5">
          <div className="grid h-12 w-12 place-items-center rounded-full bg-gold/15 text-gold mx-auto">
            <Lock size={20} />
          </div>
          <div>
            <Label className="text-white/70">Email</Label>
            <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 bg-ink border-white/15 focus-visible:ring-gold" placeholder="admin@…" />
          </div>
          <div>
            <Label className="text-white/70">Mot de passe</Label>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 bg-ink border-white/15 focus-visible:ring-gold" placeholder="••••••••" />
          </div>
          <button
            type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full rounded-full bg-gold px-6 py-3 text-sm font-medium text-black transition-colors duration-300 hover:bg-goldsoft disabled:opacity-60"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
